import { render, staticRenderFns } from "./ButtonWrapper.vue?vue&type=template&id=25f5d144&scoped=true&"
import script from "./ButtonWrapper.vue?vue&type=script&lang=js&"
export * from "./ButtonWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ButtonWrapper.vue?vue&type=style&index=0&id=25f5d144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f5d144",
  null
  
)

export default component.exports